import React, { useReducer } from 'react';
import Helmet from 'react-helmet';
import {
  func, string, array, oneOfType,
} from 'prop-types';
import useTheme from '@material-ui/styles/useTheme';
import mainReducer from './reducers';
import PmaContext from './PmaContext';
import SwitchView from './components/SwitchView';
import { mobile } from '../utils/handlers';

window.setAccessToken = accessToken => sessionStorage.setItem('accessToken', accessToken);

const mobileFunctions = {
  editAppointment: !sessionStorage.getItem('isWebApp')
    ? (apptId, editStep = '') => mobile.handler('editAppointment', { apptId, editStep })
    : (apptId, editStep = '') => window.parent.postMessage({ menu: 'appointment', params: `apptId=${apptId}&editStep=${editStep}&ver=${new Date()}` }, '*'),
  sharePRP: () => mobile.handler('sharePRP', { type: 'prospect' }),
};

const Pma = ({
  callApi, apptId, status, language,
}) => {
  let statusArray;
  const filters = {};
  if (status) {
    statusArray = Array.isArray(status) ? status : [status];
    statusArray.map((value) => {
      filters[value] = true;
      return filters;
    });
  }

  const theme = useTheme();

  const initialState = {
    apptId,
    records: [],
    profile: null,
    page: 'loading',
    search: '',
    filters,
    sort: 'NEWEST',
    hasNextPage: true,
    leadsContent: false,
    pageCount: true,
    callApi,
    statusColors: {
      new: theme.palette.colors.corePink,
      in_progress: theme.palette.colors.warning,
      awaiting_acceptance: theme.palette.colors.information,
      expired: '#A2ACAE',
      pending: theme.palette.colors.textLight,
    },
    apiBody: {
      searchStr: '',
      sortName: 'NEWEST',
      pagination: { pageSize: 20, pageIndex: 0 },
      filters: {
        Status: statusArray,
      },
    },
    language,
    ...mobileFunctions,
  };

  switch (language) {
    case 'ar':
      // set direction to rtl
      document.body.dir = 'rtl';
      break;

    case 'ru':
    case 'tr':
    case 'tl':
      // set direction to ltr
      document.body.dir = 'ltr';
      break;

    default:
      // Do nothing
      break;
  }
  return (
    <>
      <Helmet htmlAttributes={{ lang: language || 'en' }} />
      <PmaContext.Provider value={useReducer(mainReducer, initialState)}>
        <SwitchView />
      </PmaContext.Provider>
    </>
  );
};

export default Pma;

Pma.propTypes = {
  callApi: func.isRequired,
  apptId: string,
  status: oneOfType([string, array]),
  language: string,
};
